import React from 'react';
import { AppShell, Text } from '@tapresearch/ui/components';
import { useHistory } from 'react-router-dom';
import { useQueryString } from '../components/hook';
import { BreadcrumbContainer } from '../components/common/Breadcrumb';
export var HeaderContent = function(param) {
    var isHomepage = param.isHomepage;
    if (!isHomepage) return /*#__PURE__*/ React.createElement(BreadcrumbContainer, null);
    return /*#__PURE__*/ React.createElement(HomepageTabNav, null);
};
var HomepageTabNav = function() {
    var history = useHistory();
    var _useQueryString = useQueryString(), isManagedView = _useQueryString.managed;
    var matchedManaged = !!Number(isManagedView);
    var currentIndex = matchedManaged ? 1 : 0;
    var tabs = [
        {
            key: 'self_service',
            label: 'Self-service',
            onClick: function() {
                return history.push('/?managed=0');
            }
        },
        {
            key: 'managed',
            label: 'Managed',
            onClick: function() {
                return history.push('/?managed=1');
            }
        }
    ];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Text, {
        color: "trueBlack",
        fontWeight: "medium",
        fontSize: "lg"
    }, "Surveys"), /*#__PURE__*/ React.createElement(AppShell.HeaderTabs, {
        currentIndex: currentIndex >= 0 ? currentIndex : null,
        tabs: tabs
    }));
};
